/**
 * The status timeline — domain and prefix verification.
 *
 * **One component, two screens.** There are two long waits in this product and
 * they deserve one pattern, not two that drift.
 *
 * Each step carries a timestamp **or an honest expectation**. "Usually inside
 * two business days" and "depends on your provider, not on us" are both real
 * answers; a spinner with no estimate is not, and the second of those sentences
 * is doing work — during a DNS wait the user's instinct is that we are broken,
 * and saying whose hands it is in is most of the support load.
 *
 * ## The fourth domain step is a permanent fact, not a status
 *
 * *Answering scans* is the moment `domains.first_live_at` is written. That
 * timestamp **permanently** unblocks printing for the domain: it is never
 * cleared, not on a later outage, not on a failed probe, not on a regression to
 * `error` (§7, and §8.1 depends on the distinction). So it stays a distinct
 * step and the timestamp is surfaced for good once reached — a step that
 * reverts to "current" would be showing a rolling health window, which is the
 * exact thing that column is specified not to be.
 *
 * Ongoing health lives in `last_probe_ok` / `last_probe_at` and belongs
 * elsewhere on the screen. Two fields, two questions: *has this ever worked?*
 * versus *is it working right now?*
 */
import { createElement } from "react";
export const STEP_STATES = ["done", "current", "future"];
export function Timeline({ steps }) {
    return createElement("ol", { className: "pp-timeline" }, ...steps.map((step, i) => createElement("li", {
        key: `${i}-${step.label}`,
        className: "pp-timeline-step",
        "data-state": step.state,
        "aria-current": step.state === "current" ? "step" : undefined,
    }, createElement("span", { className: "pp-timeline-dot", "aria-hidden": "true" }), createElement("span", { className: "pp-timeline-label" }, step.label), step.detail === undefined
        ? null
        : createElement("span", { className: "pp-timeline-detail" }, step.detail))));
}
//# sourceMappingURL=Timeline.js.map